import Vue from 'vue';

// 表格滚动加载
Vue.directive('loadMore', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper');
    selectWrap.addEventListener('scroll', function() {
      let sign = 100;
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
      if (scrollDistance <= sign) {
        binding.value()
      }
    })
  }
});

//表格滚动条定位
Vue.directive('reScroll', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper');

    function throttle(method, context) {
      clearTimeout(method.tId);
      method.tId = setTimeout(function () { method.call(context); }, 100);
    }
    function bindingScroll() { binding.value(selectWrap.scrollTop, selectWrap.scrollLeft) }

    selectWrap.addEventListener('scroll', function() {throttle(bindingScroll)})
  },
  update(el, binding,) {
    const selectWrap = el.querySelector('.el-table__body-wrapper');
    selectWrap.scrollTop = binding.value().scrollTop;
    selectWrap.scrollLeft = binding.value().scrollLeft;
  },
});



// WEBPACK FOOTER //
// ./src/libs/directives/TableDirective.js